(function () {
  'use strict';

  function initArticle(root) {
    if (!root || root.getAttribute('data-nbp-initialized')) return;
    root.setAttribute('data-nbp-initialized', 'true');

    var revealEls = root.querySelectorAll('.nbp-reveal:not(.nbp-in)');
    if (!revealEls.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('nbp-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      revealEls.forEach(function (el, i) {
        if (el.classList.contains('nbp-related-card')) {
          el.style.transitionDelay = Math.min(i % 3, 2) * 0.08 + 's';
        }
        io.observe(el);
      });
    } else {
      revealEls.forEach(function (el) { el.classList.add('nbp-in'); });
    }
  }

  function boot() {
    document.querySelectorAll('.naseebo-article').forEach(initArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.naseebo-article');
    if (root) initArticle(root);
  });
})();